// src/pages/HomePage.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';
import Footer from '../components/Footer';
import FeaturedDishes from '../components/FeaturedDishes';
import EventsDropdown from '../components/EventsDropdown';

const HomePage = () => (
  <div>
    {/* ── Hero ── */}
    <section className="hero">
      <div className="hero__bg" aria-hidden="true" />

      <div className="hero__content">
        <p className="hero__eyebrow">Authentic Thai Cuisine · CHIJMES, Singapore</p>

        <h1 className="hero__title">
          Welcome to<br />Lebua Thai
          <span className="hero__title-line" aria-hidden="true" />
        </h1>

        <p className="hero__subtitle">
          Experience the bold flavours, vibrant spices, and warm hospitality
          of Thailand — right in the heart of Singapore.
        </p>

        <div className="hero__actions">
          <Link to="/reservation" className="btn btn-primary">
            Reserve a Table
          </Link>
          <EventsDropdown variant="hero" triggerClassName="btn btn-outline" />
        </div>
      </div>

      {/* Scroll nudge */}
      <div className="hero__scroll-hint" aria-hidden="true">
        <span />
        scroll
      </div>
    </section>

    {/* ── Featured Dishes ── */}
    <FeaturedDishes />

    <Footer />
  </div>
);

export default HomePage;
